var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cars"},[_c('div',{staticClass:"approve-box"},[_c('img',{staticClass:"approve",attrs:{"src":_vm.img.approve}}),_c('div',{staticClass:"f-12"},[_vm._v("您的认证已提交，审核时间2-3个工作日完成")])])])}
var staticRenderFns = []

export { render, staticRenderFns }